import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RSDialogComponentModel} from '../rsnotify/rsdialog.component.model';
import {RSLoadingModalSpinkitType} from './rsloading.modal.defaults';
import {ThemePalette} from '@angular/material/core';

@Component({
    selector: 'rs-loading-modal-spinkit',
    templateUrl: 'rsloading.modal.spinkit.component.html',
    styleUrls: ['rsloading.modal.spinkit.component.scss'],
    exportAs: 'RSLoadingModalSpinkitComponent',
})
export class RSLoadingModalSpinkitComponent extends RSDialogComponentModel {
    @Input('type') type$: RSLoadingModalSpinkitType = RSLoadingModalSpinkitType.ChasingDot;
    @Input('size') size$: number = 50;
    @Input('color') color$: ThemePalette | ThemePalette[] = 'primary';
    public types$ = RSLoadingModalSpinkitType;
}
